<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
</template>

<script>
export default {
  name: 'IconArrowRight',
  props: {
    size: { type: [String, Number], default: 14 },
    strokeWidth: { type: [String, Number], default: 2.4 },
  },
};
</script>
